import script from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmPassword.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmPassword.vue?vue&type=style&index=0&id=2b3f869c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b3f869c"]])

export default __exports__